import clsx from "clsx";
import TokenSelect from "~/components/TokenSelect";
import { useTranslation } from "react-i18next";
import {
    formatPrice,
    formatPercent,
    formatMarketCap,
    formatVolume,
} from "~/utils/number-format";
import { getBuySellColor, getTextSize } from "../utils";
import { Skeleton } from "antd-mobile";
import TokenHeaderSkeleton from "~/components/TokenSelect/TokenSelectSkeleton";
import TokenShare2EarnBtn from "~/components/Share2Earn/TokenShare2EarnBtn";

export default function KDetailHeader({
    tokenInfo = {},
    chain_id,
    contract,
    tokenSelectCallback,
}: any) {
    const { t } = useTranslation();
    const token_base = tokenInfo.token_base || {};
    const token_market = tokenInfo.token_market || {};

    const { chain_name, chain_logo, logo, symbol } = token_base;
    const {
        market_cap,
        tvl_usd,
        volume_value,
        price,
        change = 0,
    } = token_market;

    function KvDesc({ k = "", v = "", className = "" }) {
        return (
            <div
                className={clsx(
                    "flex items-center text-direction2 justify-between",
                    className
                )}
            >
                <div className="text-text_2 font-Regular whitespace-nowrap">
                    {k}
                </div>
                <div className="text-text_1 font-Semibold whitespace-nowrap text-right">
                    {v}
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="flex justify-between h-[66px] left-0 px-4 -top-[0.5px] py-3 items-center sticky bg-bg_0 w-full z-30">
                {chain_name ? (
                    <TokenSelect
                        chainId={chain_id}
                        symbol={symbol}
                        logo={logo}
                        chainName={chain_name}
                        chainLogo={chain_logo}
                        contract={contract}
                        tokenSelectCallback={tokenSelectCallback}
                    />
                ) : (
                    <TokenHeaderSkeleton />
                )}
                <div className="flex">
                    <TokenShare2EarnBtn token={tokenInfo} />
                </div>
            </div>

            <div className="flex justify-between w-full px-4">
                {Object.keys(token_market).length > 0 ? (
                    <div className="mt-[-4px] flex-none w-[70%]">
                        <div
                            className="font-Semibold text-text_1 whitespace-nowrap"
                            style={{
                                ...getTextSize(formatPrice(price).length),
                            }}
                        >
                            {formatPrice(price)}
                        </div>
                        <div
                            className={clsx(
                                "text-body4 font-Semibold whitespace-nowrap mt-[2px]",
                                getBuySellColor(change)
                            )}
                        >
                            {formatPercent(change)}
                        </div>
                    </div>
                ) : (
                    <div className="flex  flex-col">
                        <Skeleton
                            animated
                            className={"w-[120px] h-[50px] rounded-[2px]"}
                        />
                        <div className="h-[2px]"></div>
                        <Skeleton
                            animated
                            className={"w-[76px] h-[16px] rounded-[2px]"}
                        />
                    </div>
                )}
                <div className="flex-none w-[30%]">
                    <KvDesc k={t("mkt_cap")} v={formatMarketCap(market_cap)} />
                    <KvDesc
                        k={t("tvl")}
                        v={formatMarketCap(tvl_usd)}
                        className="mt-[6px]"
                    />
                    <KvDesc
                        k={t("vol24")}
                        v={formatVolume(volume_value)}
                        className="mt-[6px]"
                    />
                </div>
            </div>
        </>
    );
}
